module.exports = __webpack_public_path__ + "img/T6-C-xh_1.ba032e75.png";